import {
  AllocationDataImpl,
  OrderIntent,
  Product,
  RequestOrderType,
} from "shared/cubiq-model-multi-asset";
import { BMRiskUtils, RiskAggregate } from "../benchmarks/helpers/BMRiskUtils";
import { BmarkRiskData } from "../benchmarks/BmarkRiskData.model";

export type IntentDetails = {
  label: string;
};

export class ProductIntentRenderer {
  static render(
    orderIntent: OrderIntent,
    fixedCCY: string,
    product: Product,
    orderType: RequestOrderType,
    allocationData: AllocationDataImpl[],
    risk: BmarkRiskData,
  ): any {
    let risks: RiskAggregate = null;

    if (allocationData != null) {
      risks = BMRiskUtils.aggregateAllocations(fixedCCY, product, allocationData);
    }

    if (Product.SWP == product) {
      if (risk != null) {
        return this.makeSwapIntentDescriptionFromRisk(risk);
      } else {
        return this.makeSwapIntentDescription(risks);
      }
    } else if (RequestOrderType.CALL == orderType) {
      return "CALL";
    } else if (risks != null && risks.allocations != null && risks.allocations.length > 1) {
      /* Multi Alloc */
      // return this.makeBulkedIntentDescription(risks.buyCount, risks.sellCount);
    }

    return this.getClientIntentStringFromIntent(orderIntent);
  }

  private static makeSwapIntentDescriptionFromRisk(risk: {
    nearIntent: OrderIntent;
    farIntent: OrderIntent;
  }): string {
    const nearIntent = this.getClientIntentStringFromIntent(risk?.nearIntent);
    const farIntent = this.getClientIntentStringFromIntent(risk?.farIntent);
    return `${nearIntent}/${farIntent}`;
  }

  private static makeSwapIntentDescription(risks: RiskAggregate): string {
    const nearIntent = this.getClientIntentStringFromIntent(risks?.swapNearAlloc?.allocationIntent);
    const farIntent = this.getClientIntentStringFromIntent(risks?.swapFarAlloc?.allocationIntent);
    return `${nearIntent}/${farIntent}`;
  }

  private static makeBulkedIntentDescription(buyCount, sellCount): string {
    const intents = [];
    if (buyCount > 0) {
      intents.push(`${buyCount} Buy${buyCount > 1 ? "s" : ""}`);
    }
    if (sellCount > 0) {
      intents.push(`${sellCount} Sell${sellCount > 1 ? "s" : ""}`);
    }
    return intents.join("/");
  }

  public static getClientIntentStringFromIntent(intent: OrderIntent) {
    return OrderIntent.BUY == intent ? "BUY" : "SELL";
  }

  // private static createCallIntentDetails():IntentDetails{

  // }
}
